module.exports = __webpack_public_path__ + "img/list-function.ca75024a.png";